import React from "react";

export const MenuDivider = ({ children }: MenuDividerProps): React.JSX.Element => {
    return (
        <div className="-mt-6 text-secondary py-3 flex items-center text-sm uppercase before:flex-1 before:border-t before:border-gray-200 before:me-4 after:flex-30 after:border-t after:border-gray-200 after:ms-4">
            {children}
        </div>
    );
};

interface MenuDividerProps {
    children: React.ReactNode;
}

export default MenuDivider;